import {Model} from "./base/Model";
import {Collection} from "./base/Collection";
import { v4 as uuid } from "uuid";

import { IAddress, AddressModel } from "./Address"
import { InvoiceRow } from "./InvoiceRow";


    export class InvoiceModel extends Model  {
      customer: Object;
      subtotal: number = 0;
      vat_total: number = 0;
      tax:Object = {}
      invoice_total: number = 0;
      invoice_prefix: string = "";
      invoice_number: number = 0;
      invoice_date: string;
      created_at: string;
      created_by: string;
      key: string = "";
      rows: Collection = new Collection();
       
        constructor(data = null, vatRates = null) {
            super(data);
            if(data) {
                this.createModel(data, {rows: InvoiceRow});
                //this.syncData(data);
            }
            if(vatRates) {
                this.setVatRates(vatRates);
            }
        }   
        

      public setVatRates(vatRates) {
          (vatRates).map((item) => {
              this.tax[item["key"]] = {
                  label: item["name"],
                  amount: 0
              }
          })
      }
      public syncData(data) {
            if(data) {
                Object.keys(data).map((item) => {
                        if(item != "rows") {
                            this[item] = data[item];
                        } else {
                            for(let i in data[item]) {
                                let invoiceRow = new InvoiceRow(data[item][i] );
                                this.rows.add(invoiceRow);
                            }                        
                        }
                    //}
                });
            }
      }
    
    public addRow(invoiceRow) {
        if(invoiceRow) {
            invoiceRow.calculate();
            this.rows.add(invoiceRow);
            this.calculateTotals();
        }
        
    }

    public replaceRow(invoiceRow) {
        if(invoiceRow) {
            invoiceRow.calculate();
            this.rows.for( function(item) {
                if(item.uid == invoiceRow.uid) {
                    item = invoiceRow;
                    return;
                }
            })
//            this.rows.add(invoiceRow);
            this.calculateTotals();
        }
        
    }
    
    public recalcRows=() => {
        
    }
    
    
    public calculateTotals() {
        let subtotal = 0;
        let vat_total = 0
        let invoice_total = 0;
        if(this.rows && this.rows.length > 0) {
            let rows = this.rows.get();
            Object.keys(this.tax).map((key) => {this.tax[key]['amount'] = 0;});
            
            
            if(rows) {
                for(let i in rows) {
                    let rowData = rows[i];
                    subtotal += rowData.total_price;
                    if(rowData.vatrate_key) {
                        this.tax[rowData.vatrate_key]['amount'] += rowData.getVatTotal();
                        invoice_total += (rowData.price * rowData.amount) + rowData.getVatTotal();
                    }
                }

            }
        }
        this.subtotal = subtotal;
        this.invoice_total = invoice_total;
        this.vat_total = vat_total;
    }
 
         
}